<template>
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h2 class=" mt-5">Congratulations!</h2>
                <p class="font-weight-bold h5">Your MySwitchPro setup is now completed! Time to sit back and relax!</p>
                <hr class="mt-5">

            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6 mx-auto py-3 text-center">
                <h2 class="mt-5">What Happens Next?</h2>
            </div>
        </div>
        <div class="row no-gutters align-items-center py-4" v-if="!hasWorthlessDeal">
            <div class="col-12 col-lg-6 text-center text-lg-right px-5 my-5 my-lg-0">
                <img src="../../assets/images/complete1.png" alt="home1" class="img-fluid" />
            </div>
            <div class="col-12 col-lg-6  text-center text-lg-left">
                <h2 class="w-75 mx-auto mx-lg-0 mb-5 mb-lg-5">We’ll notify your new supplier</h2>
                <p>We’ll pass your details to your new energy supplier so they can start billing you when your switch is completed.</p>
            </div>
        </div>
        <hr v-if="!hasWorthlessDeal">
        <div class="row no-gutters align-items-center flex-lg-row-reverse  py-4 " v-if="!hasWorthlessDeal">
            <div class="col-12 col-lg-6 text-center text-lg-left px-5 my-5 my-lg-0">
                <img src="../../assets/images/complete2.png" alt="companies" class="img-fluid" />
            </div>
            <div class="col-12 col-lg-6 text-center text-lg-right">
                <h2 class="w-75 mx-auto mx-lg-0 mb-5 mb-lg-5 ml-lg-auto ">We’ll tell you in advance when
                    your next switch is due</h2>
                <p>In the meantime, MySwitchPro will actively monitor the energy market and notify you in advance when your next switch is due and how much you will save.</p>
            </div>
        </div>
        <div class="row no-gutters align-items-center flex-lg-row-reverse  py-4 " v-if="hasWorthlessDeal">
            <div class="col-12 col-lg-6 text-center text-lg-left px-5 my-5 my-lg-0">
                <img src="../../assets/images/complete2.png" alt="companies" class="img-fluid" />
            </div>
            <div class="col-12 col-lg-6 text-center text-lg-right">
                <h4 class="w-75 mx-auto mx-lg-0 mb-5 mb-lg-5 ml-lg-auto ">
                    MySwitchPro will now find the energy deal, saving you most money and then notify you when your switch is due.
                </h4>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-8 mx-auto">
                <p class="text-center h5 font-weight-normal my-5">Don’t worry, you don’t have to do anything! MySwitchPro will take care of everything!
                If you plan to move home, please remember to let us know by logging into MySwitchPro online dashboard and updating your details.</p>
            </div>
        </div>
        <hr>
        <div class="row">
            <div class="col-12 col-lg-4 mx-auto mt-4 mb-5">
                <router-link class="btn btn-success btn-success-gradient btn-lg btn-block" :to="{name: 'Dashboard'}">
                    Go to my dashboard
                    <i class="fa fa-long-arrow-right float-right mt-1"></i>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
        name: "Complete",
        computed: {
            ...mapGetters('auth', ['hasWorthlessDeal'])
        }
    }
</script>

<style scoped>

</style>
